function createCookie(name,value,minutes) {
  if (minutes) {
    var date = new Date();
    date.setTime(date.getTime()+(minutes*60*1000));
    var expires = "; expires="+date.toGMTString();
  } else {
    var expires = "";
  }
  document.cookie = name+"="+value+expires+"; path=/";
}

if (document.cookie.includes('formSubmitted=true')) {
  document.querySelector('#contactUsForm').classList.add('form-submitted');
}

const contactUsForm = document.getElementById('contactUsForm');
if (contactUsForm) {
  const zapierPath = contactUsForm.dataset.zapierPath;
  const zapierID = contactUsForm.dataset.zapierId;
  contactUsForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const formData = new FormData(contactUsForm);
    fetch('https://hooks.zapier.com/hooks/catch/'+zapierPath+'/'+zapierID+'/', {
      method: 'post',
      body: formData
    }).then((response) => response.json())
    .then((text) => {
      document.querySelector('#contactUsForm').classList.add('form-submitted');
      createCookie("formSubmitted", "true", 5);
    })
    .catch((error) => console.error(error))
  });
}